<template>
  <div class="nav-wraper max-md:!w-[100%]" :class="`nav-wraper--${createRenderType}`">
    <div class="height-all nav-box max-md:!flex-row max-md:!items-center max-md:!justify-between">
      <div class="nav-logo max-md:!w-[106px] max-md:px-[8px]">
        <img src="@/assets/img/logo.png" class="max-md:!w-[100%]" alt="" />
      </div>
      <!-- pc -->
      <template v-if="width > 780">
        <div class="nav-wraper-main">
          <template v-for="(item, index) in getNavs()" :key="item.routername">
            <div
              class="nav-item tl pointer"
              :class="{
                active: item.routername == matchHighLight,
              }"
              @click="goRouter(item)"
            >
              <div>
                <span class="fn-inline text">{{ item.label }}</span>
                <SvgIcon class="w-[20px] h-[20px] arrowIcon" v-if="item.showArrow" name="arrow" />
              </div>
            </div>
          </template>
        </div>
        <div class="user-nav-list">
          <div class="avatar pointer">
            <div class="pc" v-if="userDataStore.isLogin">
              <el-dropdown
                v-if="renderData.ifRenderLangPopover"
                ref="refElDropdown"
                placement="top"
                popper-class="header-drop"
                trigger="click"
                @command="handleCommand"
              >
                <div class="el-dropdown-link">
                  <img
                    v-if="userDataStore?.userInfo?.user?.profile_image"
                    :src="getObjectStorageFullUrl(userDataStore?.userInfo?.user?.profile_image)"
                    alt="header"
                  />
                  <div>
                    <div class="username">
                      {{ userDataStore?.userInfo?.user?.stage_name }}
                    </div>
                    <div class="email">
                      {{ truncatedEmail(userDataStore?.userInfo?.user?.email) }}
                    </div>
                  </div>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item v-if="globleConfig.appname != 'Mureka'" command="authentication">认证信息</el-dropdown-item>
                    <el-dropdown-item command="terms">{{ $t("common.terms_of_service") }}</el-dropdown-item>
                    <el-dropdown-item command="privacy">{{ $t("common.privacy_policy") }}</el-dropdown-item>
                    <el-dropdown-item command="logout">{{ $t("common.sign_out") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="unlogin" v-if="!userDataStore.isLogin" @click="showLogin">
              {{ $t("common.sign_in") }}
            </div>
          </div>
        </div>
      </template>
      <!-- moblie -->
      <template v-else>
        <div class="flex gap-[8px] items-center mr-[8px]">
          <el-dropdown placement="bottom" popper-class="header-drop" trigger="click">
            <div class="el-dropdown-link">
              <SvgIcon name="menu" class="w-[20px] h-[20px]" />
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item, index) in getNavs()" :key="index" @click="goRouter(item)">{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div class="w-fit">
            <div v-if="userDataStore.isLogin">
              <el-dropdown
                v-if="renderData.ifRenderLangPopover"
                ref="refElDropdown"
                placement="bottom"
                popper-class="header-drop"
                trigger="click"
                @command="handleCommand"
              >
                <div class="el-dropdown-link">
                  <img
                    class="w-[24px] rounded-[50%]"
                    v-if="userDataStore?.userInfo?.user?.profile_image"
                    :src="getObjectStorageFullUrl(userDataStore?.userInfo?.user?.profile_image)"
                    alt="header"
                  />
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item v-if="globleConfig.appname != 'Mureka'" command="authentication">认证信息</el-dropdown-item>
                    <el-dropdown-item command="terms">{{ $t("common.terms_of_service") }}</el-dropdown-item>
                    <el-dropdown-item command="privacy">{{ $t("common.privacy_policy") }}</el-dropdown-item>
                    <el-dropdown-item command="logout">{{ $t("common.sign_out") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="unlogin bg-[#0000000d] px-[4px] py-[2px] rounded-[12px]" v-if="!userDataStore.isLogin" @click="showLogin">
              {{ $t("common.sign_in") }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, reactive, watch, defineExpose, onMounted, getCurrentInstance, ref } from "vue"
import { $$t } from "@/i18n/i18n.js"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"

import globleConfig from "@/config/config.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

import { useRouter, useRoute } from "vue-router"

import useUserDataStore from "@/store/userDataStore.js"
import { isDev } from "@/utils/tools.js"
import apiUser from "@/api/api/apiUser.js"
import { funComponentList } from "@/components/functionComp/index"

import { showActionDialog } from "@/components/functionCallComponent/action/action.js"

import { useWindowSize } from "@vueuse/core"
import GlobalConfig from "@/config/config.js"
import message from "@/components/functionCallComponent/message/message.js"
import ShowAuthenticationSelect from "@/components/authenticationSelect/authenticationSelect.js"

const { width, height } = useWindowSize()

const Router = useRouter()
const route = useRoute()
const userDataStore = useUserDataStore()
const globalProperties = getCurrentInstance()?.appContext.config.globalProperties

const matchHighLight = computed(() => {
  return route?.meta?.title ?? ""
})

const refElDropdown = ref(null)

const props = defineProps({})
const emits = defineEmits([])
const stateData = {}
const getNavs = () => {
  return [
    {
      label: $$t("common.overview"),
      routername: "overview",
      mobileVisible: true,
      code: 0,
    },
    {
      label: $$t("common.pricing"),
      routername: "pricing",
      mobileVisible: true,
      code: 2,
    },
    {
      label: $$t("common.documentation"),
      routername: "documentation",
      mobileVisible: true,
      showArrow: true,
      code: 3,
    },
    {
      label: $$t("common.api_keys"),
      routername: "apiKeys",
      mobileVisible: true,
      code: 1,
    },
    {
      label: $$t("common.mcp"),
      routername: "mcp",
      mobileVisible: true,
      code: 5,
    },
    {
      label: $$t("common.billing"),
      routername: "billing",
      mobileVisible: true,
      code: 4,
    },
    // {
    //   label: "Terms & Policies",
    //   routername: "terms",
    //   mobileVisible: true,
    //   code: 5,
    // },
  ]
}

const userActiveNav = ref("")

const renderData = reactive({
  curnav: "",
  ifRenderLangPopover: true,
})

const truncatedEmail = (email) => {
  if (!email) return ""
  const [localPart, domainPart] = email.split("@")
  const localFormatted = localPart.length > 10 ? localPart.slice(0, 10) + "..." : localPart
  const domainFormatted = domainPart && domainPart.length > 10 ? domainPart.slice(0, 10) + "..." : domainPart
  return domainFormatted ? `${localFormatted}@${domainFormatted}` : localFormatted
}

const gorouter = async (item) => {
  if (item.routername == "apiKeys" || item.routername == "billing") {
    if (
      (await userDataStore.checkLoginStatus({
        source: item.routername,
      })) !== "login"
    ) {
      return
    }
  }
   if (item.routername == "mcp") {
    window.open('https://github.com/SkyworkAI/Mureka-mcp', "_blank")
    return
  }
  if (item.routername == "documentation") {
    const url = `https://${isDev() ? "platform-test" : "platform"}.mureka.${globleConfig.appname == "MurekaCn" ? "cn" : "ai"}/docs/${
      globleConfig.appname == "MurekaCn" ? "cn" : "en"
    }/quickstart.html`
    window.open(url, "_blank")
    return
  }
  Router.push({ name: item.routername })
}

const goRouter = (item) => {
  gorouter(item)
}

const handleCredits = () => {
  Router.push({
    name: "subscribe",
  })
}

const showLogin = () => {
  if (GlobalConfig.appname == "MurekaCn") {
    funComponentList.LogInCn({
      handleOk: (str) => {
        // callback && callback(this.isLogin)
      },
      handleCancel: () => {
        // callback && callback(false)
      },
    })
  } else {
    funComponentList.ThirdLogin({
      handleOk: (str) => {
        console.log("点击成功" + str)
        console.log("userDataStore.isLogin", userDataStore.isLogin)
      },
    })
  }
}

const handleCommand = (command) => {
  switch (command) {
    case "edit":
      console.log(`click on item ${command}`)
      funComponentList.EditUserInfo({
        handleOk: (str) => {},
      })
      break
    case "logout":
      logOutApi()
      break
    case "order":
      Router.push({
        name: "order",
      })
      break
    case "earnings":
      Router.push({
        name: "sald",
      })
      break
    case "authentication":
      ShowAuthenticationSelect()
      break
    case "terms":
      window.open(
        import.meta.env.VITE_PLATFORM_API_URL + (globleConfig.appname == "MurekaCn" ? "/service_terms_cn.pdf" : "/service_terms.pdf"),
        "_blank"
      )
      break
    case "privacy":
      window.open(
        import.meta.env.VITE_PLATFORM_API_URL + (globleConfig.appname == "MurekaCn" ? "/privacy_policy_cn.pdf" : "/privacy_policy.pdf"),
        "_blank"
      )
      break
    case "switchLanguage":
      break
    default:
      console.log(`Unknown command: ${command}`)
  }
}
const refPopover = ref(null)
const handleLanguageChange = (val) => {
  renderData.ifRenderLangPopover = false
  nextTick(() => {
    renderData.ifRenderLangPopover = true
    nextTick(() => {
      userDataStore.switchLanguage(val.key)
    })
  })
}

const handleUserNavClick = async (item) => {
  switch (item.name) {
    case "invite":
      globalProperties.logClickEvent("invite_for_free_credits")
      if ((await userDataStore.checkLoginStatus()) !== "login") {
        return
      }
      break
    case "news":
      globalProperties.logClickEvent("what_is_new")
      break
    case "faq":
      Router.push({
        name: "faq",
      })
      break
    case "about":
      globalProperties.logClickEvent("catalog_about_mureka")
      Router.push({
        name: "about",
      })
      break
    default:
      console.log(`Unknown command: ${item}`)
  }
  userActiveNav.value = item.name
}

const logOutApi = async () => {
  const { data, code, msg } = await apiUser.userLoginOut({}, userDataStore.authData.user_id)
  if (code == 200) {
    userDataStore.clearAll()
    Router.push({
      name: "overview",
    })
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    })
  }
}

watch(
  () => route.name,
  (newVal, oldVal) => {
    renderData.curnav = newVal
  }
)

onMounted(() => {
  renderData.curnav = route.name
})
</script>
<style lang="scss" scoped>
.nav-wraper {
  width: 200px;
  height: 100%;
  padding: 18px 0 0 0;
  .nav-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .nav-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      img {
        width: 156px;
        height: auto;
      }
      .yinfeng-logo {
        width: 126px;
        height: auto;
      }
    }
  }
  .user-nav-list {
    color: #000;
    .user-nav-box {
      padding-left: 16px;
      margin-bottom: 20px;
      .user-nav-item {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 12px;
        opacity: 0.8;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-left: 5px;
        }

        &:last-child {
          margin-bottom: 0;
        }
        .red-dot {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ff5f74;
          transform: translate(5px, -5px);
        }
      }
      .pointer {
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  .nav-item {
    margin: 0 20px;
    line-height: 44px;
    border-radius: 8px;
    i.ico {
      margin-left: 20px;
      width: 24px;
      height: 24px;
      opacity: 5;
    }
    .text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.04em;
      color: rgba(0, 0, 0, 0.5);
      margin-left: 12px;
    }
    .arrowIcon {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .nav-item:hover {
    .text {
      color: #3d3d3d;
      font-weight: bold;
    }
    .arrowIcon {
      color: #000;
      font-weight: bold;
    }
  }
  .nav-item.active {
    background: rgba(0, 0, 0, 0.05);
    i.ico {
      opacity: 1;
    }
    .text {
      color: #3d3d3d;
      font-weight: bold;
    }
  }
  &.nav-wraper--mobile {
    padding: 0 16px;
    position: relative;
    .nav-wraper-main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
    }

    .nav-item {
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: max-content;
      padding: 0 10px;
      justify-content: center;
      margin-bottom: 4px;
      i.ico {
        display: none;
        margin: 0 auto;
        line-height: 20px;
        height: 20px;
        width: 20px;
      }
      .text {
        color: rgba(255, 255, 255, 0.5);
        line-height: 24px;
        margin: 0;
        font-size: 16px;
      }
    }
    .nav-item:hover {
      .text {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .avatar {
    margin: 0 16px 20px;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 60px;
    overflow: hidden;
    .pc {
      width: 100%;
      padding: 7px 10px;
    }
    .unlogin {
      width: 100%;
      height: 44px;
      font-size: 16px;
      font-weight: 900;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 50px;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    :deep(.el-dropdown) {
      width: 100%;
      .el-dropdown-link {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          border-radius: 50%;
          width: 28px;
          height: 28px;
          min-width: 28px;
          border: none;
          display: block;
        }
        .username {
          color: #000000;
          margin-left: 7px;
          flex-grow: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
        }
        .email {
          margin-left: 7px;
          font-size: 10px;
          line-height: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
    &:hover {
      opacity: 0.8;
    }

    .mobile {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .avatar {
      display: none;
    }
    .user-nav-list {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.header-drop {
  .el-popper__arrow {
    display: none !important;
  }
  .el-dropdown-menu__item:not(.is-disabled):focus {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .el-dropdown-menu {
    background: rgba(0, 0, 0, 0.05);
    .el-dropdown-menu__item {
      color: #000;
      padding: 8px 20px;
      font-weight: 400;
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
      &.switch-language-drop-item {
        padding: 0;
        .switch-language {
          padding: 8px 20px;
          width: 100%;
        }
      }
    }
  }
}
</style>
